// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2P3kl","select":"Header_select__15kRx","clinic":"Header_clinic__21Fy8"};